import type { WizardComponentAdapterProps } from '@lemonade-hq/chat-wizard-client-base';
import type { UniclientComponentTitle } from '@lemonade-hq/uniclient-chat';
import { Flex, Text } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import React from 'react';
import type { TitleContentProps } from './TitleContent';
import { TitleContent } from './TitleContent';
import { MAIN_GRID_COLUMNS } from './Wizard.css';
import { WizardLayoutContainer } from './WizardLayoutContainer';
import * as styles from './WizardTitle.css';

export const TITLE_COLUMNS = 4;

interface WizardTitleProps {
  readonly animationDelay?: number;
  readonly title: UniclientComponentTitle;
  readonly loading?: boolean;
  readonly onAction?: WizardComponentAdapterProps['onAction'];
  readonly titleKey?: string;
}

const getTitleProps = (title: UniclientComponentTitle): TitleContentProps => {
  if (typeof title === 'object' && 'mode' in title) {
    if (title.mode === 'reasoning') {
      return { mode: 'reasoning', titleText: title.text };
    } else {
      return { mode: 'typing', titleText: title.text };
    }
  } else {
    return { mode: 'typing', titleText: title };
  }
};

export const WizardTitle: React.FC<WizardTitleProps> = ({ title, loading = false, onAction, titleKey }) => {
  const titleProps = getTitleProps(title);
  const isLoading = loading || title === '';

  return (
    <Flex as={motion.div} flexDirection="column" layout="position" width="100%">
      <WizardLayoutContainer
        columns={{
          sm: MAIN_GRID_COLUMNS.sm,
          md: TITLE_COLUMNS,
        }}
      >
        <Text
          className={styles.titleText}
          color="$textPrimary"
          gridColumn={{
            sm: `span ${MAIN_GRID_COLUMNS.sm}`,
            md: `span ${MAIN_GRID_COLUMNS.md}`,
            lg: `span ${TITLE_COLUMNS}`,
          }}
          type="h5"
        >
          <TitleContent {...titleProps} loading={isLoading} onAction={onAction} titleKey={titleKey} />
        </Text>
      </WizardLayoutContainer>
    </Flex>
  );
};
